import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-6 pt-6 pb-8 overflow-hidden divide-y divide-gray-200 sm:divide-y-0 sm:grid sm:grid-cols-2 sm:gap-6" }
const _hoisted_2 = {
  class: "relative group shadow-custom hover:shadow-none rounded-xl transition duration-500 ease-in-out p-6",
  style: {"background-color":"#bfeacf"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "rounded-md inline-flex p-3 bg-white text-green-700 ring-4 ring-white" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "h-6 w-6",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      stroke: "currentColor",
      "aria-hidden": "true"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1",
        d: "M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"
      })
    ])
  ])
], -1)
const _hoisted_4 = { class: "mt-8" }
const _hoisted_5 = { class: "text-lg font-medium text-green-900" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "absolute inset-0 text-green-900",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Installeerimine ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-base font-light text-green-900" }, " Toothy Tron programmi installimine arvutisse ja ühendamine kabinetiga. ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "pointer-events-none absolute top-6 right-6 text-white group-hover:text-green-900 transition duration-500 ease-in-out",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "h-6 w-6",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z" })
  ])
], -1)
const _hoisted_10 = { class: "relative group shadow-custom hover:shadow-none rounded-xl bg-white border border-gray-200 transition duration-500 ease-in-out p-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "rounded-md inline-flex p-3 bg-red-50 text-red-600 ring-4 ring-red-50" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "h-6 w-6",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      stroke: "currentColor",
      "aria-hidden": "true"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1",
        d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
      })
    ])
  ])
], -1)
const _hoisted_12 = { class: "mt-8" }
const _hoisted_13 = { class: "text-lg font-medium text-red-900" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  class: "absolute inset-0",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Deinstalleerimine ")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-base font-light text-red-900" }, " Toothy Tron programmi ja kabineti seadete kustutamine arvutist. ", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", {
  class: "pointer-events-none absolute top-6 right-6 text-red-900 transition duration-500 ease-in-out",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "h-6 w-6",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z" })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h3", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: { name: _ctx.RouteName.DOCUMENTATION_INSTALL },
            class: "focus:outline-none uppercase"
          }, {
            default: _withCtx(() => [
              _hoisted_6,
              _hoisted_7
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _hoisted_8
      ]),
      _hoisted_9
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("h3", _hoisted_13, [
          _createVNode(_component_router_link, {
            to: { name: _ctx.RouteName.DOCUMENTATION_UNINSTALL },
            class: "focus:outline-none uppercase"
          }, {
            default: _withCtx(() => [
              _hoisted_14,
              _hoisted_15
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _hoisted_16
      ]),
      _hoisted_17
    ])
  ]))
}